(() => {
  const q = (s, root = document) => root.querySelector(s);
  const qa = (s, root = document) => [...root.querySelectorAll(s)];
  const drawer = q('[data-sb-cart-drawer]');
  const body = q('[data-sb-cart-body]');
  const footer = q('[data-sb-cart-footer]');
  let lastFocus = null;

  const formatMoney = (cents) => {
    const format = window.SBrownART?.moneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, value).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  };

  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sb-cart-is-open');
    q('[data-sb-cart-close]', drawer)?.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sb-cart-is-open');
    lastFocus?.focus?.();
  };

  const renderCart = (cart) => {
    qa('[data-sb-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    qa('[data-sb-cart-heading-count]').forEach((el) => el.textContent = `(${cart.item_count})`);
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="sb-cart-drawer__empty"><p>Your cart is waiting for something beautiful.</p><a class="sb-button sb-button--gold" href="/collections/all">Explore artwork</a></div>';
      if (footer) footer.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map((item, index) => `
      <article class="sb-cart-drawer__item" data-key="${item.key}">
        <a href="${item.url}" class="sb-cart-drawer__image">${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}</a>
        <div class="sb-cart-drawer__details">
          <a href="${item.url}"><h3>${escapeHtml(item.product_title)}</h3></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <p>${formatMoney(item.final_price)}</p>
          <div class="sb-cart-drawer__quantity">
            <button type="button" data-sb-cart-change="${index + 1}" data-quantity="${Math.max(0,item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-sb-cart-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button class="sb-cart-drawer__remove" type="button" data-sb-cart-change="${index + 1}" data-quantity="0">Remove</button>
        </div>
        <strong>${formatMoney(item.final_line_price)}</strong>
      </article>`).join('');
    q('[data-sb-cart-total]')?.replaceChildren(document.createTextNode(formatMoney(cart.total_price)));
    if (footer) footer.hidden = false;
  };
  const escapeHtml = (text='') => text.replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  const getCart = async () => (await fetch(`${window.SBrownART.cartUrl}.js`, { headers: { Accept: 'application/json' } })).json();
  const changeCart = async (line, quantity) => {
    const response = await fetch(`${window.SBrownART.cartChangeUrl}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})});
    if (!response.ok) throw new Error('Unable to update cart');
    return response.json();
  };

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-sb-cart-open]');
    if (open) { event.preventDefault(); openDrawer(); return; }
    if (event.target.closest('[data-sb-cart-close]')) { closeDrawer(); return; }
    const change = event.target.closest('[data-sb-cart-change]');
    if (change) {
      change.disabled = true;
      try { renderCart(await changeCart(Number(change.dataset.sbCartChange), Number(change.dataset.quantity))); }
      catch (e) { console.error(e); }
      return;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.noAjax === 'true') return;
    event.preventDefault();
    const button = q('[name="add"]', form) || q('button[type="submit"]', form);
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${window.SBrownART.cartAddUrl}.js`, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item');
      renderCart(await getCart());
      openDrawer();
    } catch (error) {
      let message = q('[data-sb-product-error]', form);
      if (!message) { message = document.createElement('p'); message.dataset.sbProductError=''; message.className='sb-product-error'; form.append(message); }
      message.textContent = error.message;
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-sb-variant-select]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const form = select.closest('form');
    const button = q('[name="add"]', form);
    const price = q('[data-sb-product-price]', form.closest('.sb-product-info'));
    const available = option.dataset.available === 'true';
    if (price) price.textContent = option.dataset.price;
    if (button) { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out'; }
    const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });
})();
